import { Grid } from "@material-ui/core";
import styled from "styled-components";

const WrapperBody = styled(Grid)`
	padding: 15px;
`;

export default WrapperBody;
